module.exports = __webpack_public_path__ + "static/media/Cotizador3.cd82c7eb.png";